import React, { use, useMemo, useState } from "react";
import styles from "./index.module.scss";
import { concatAddress } from "@/utils/concat-address";
import { BiCopy } from "react-icons/bi";
import Image, { type StaticImageData } from "next/image";
import mockLogo from "@public/chain-logos/low-res/ethereum-logo.png";
import BridgeTooltip from "@/components/layout/tooltip";
import { useAccount } from "wagmi";
import classNames from "classnames";
import type { ChainData } from "@/constants/chain-details";
import Link from "next/link";

type Props = {
  text: string | undefined;
  icon?: StaticImageData | undefined;
  iconTooltipText?: string;
  hideIcon?: boolean;
  link?: string;
  preventConcatenation?: boolean;
  count?: number;
  hideCopy?: boolean;
};
const CopyableText = ({
  text,
  iconTooltipText,
  hideIcon = false,
  preventConcatenation = false,
  link,
  icon,
  count,
  hideCopy = false,
}: Props) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1000); // Reset after 2 sec
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  const formattedText = useMemo(
    () => (preventConcatenation ? text : concatAddress(text, count, count)),
    [count, preventConcatenation, text],
  );

  return (
    <div
      className={classNames(
        styles.copyableContainer,
        // address === walletAddress?.toLowerCase() && styles.isWalletAddress
      )}
    >
      {!hideIcon && (
        <BridgeTooltip text={iconTooltipText || ""}>
          {icon && <Image src={icon} alt="qwdwqd" width={25} height={25} />}
        </BridgeTooltip>
      )}
      <span>
        {link ? (
          <Link href={link} target="_blank">
            {formattedText}
          </Link>
        ) : (
          formattedText
        )}
      </span>

      {!hideCopy && (
        <button
          className={classNames(styles.copyBtn, copied && styles.copied)}
          onClick={handleCopy}
        >
          <BiCopy size={16} />
        </button>
      )}
    </div>
  );
};

export default CopyableText;
